import React, { useEffect } from 'react';

const BuyWithPrimeWidget = ({ sku }) => {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const SCRIPT_SRC = 'https://code.buywithprime.amazon.com/bwp.v1.js';
    const WIDGET_CONTAINER_ID = 'amzn-buy-now';
    const MAX_RETRIES = 20;
    const RETRY_INTERVAL = 500;
    let retries = 0;

    // Inject script if not already added
    const loadScript = () => {
      if (!document.querySelector(`script[src="${SCRIPT_SRC}"]`)) {
        const script = document.createElement('script');
        script.src = SCRIPT_SRC;
        script.async = true;
        script.setAttribute('fetchpriority', 'high');
        document.head.appendChild(script);
      }
    };

    // Initialize BWP widget if possible
    const initWidget = () => {
      const container = document.getElementById(WIDGET_CONTAINER_ID);
      if (window.bwp?.updateWidget && container) {
        window.bwp.updateWidget(sku);
        console.log('✅ BWP widget initialized');
        return true;
      }
      return false;
    };

    // Retry logic
    const waitForWidget = () => {
      const interval = setInterval(() => {
        if (initWidget()) {
          clearInterval(interval);
        } else if (++retries >= MAX_RETRIES) {
          console.warn('❌ BWP widget failed to initialize after retries');
          clearInterval(interval);
        }
      }, RETRY_INTERVAL);
    };

    // Observe if the widget container is re-rendered
    const observer = new MutationObserver(() => {
      initWidget();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    loadScript();
    waitForWidget();

    return () => {
      observer.disconnect();
    };
  }, [sku]);

  return (
    <div
      id="amzn-buy-now"
      data-site-id="8chlcznvx9"
      data-widget-id="w-eBKEkAAfBm330FAemKJH21"
      data-sku={sku}
   ></div>
  );
};

export default BuyWithPrimeWidget;
